/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { IAwardCategoriesRequest } from "Interfaces/AwardCategories/IAwardCategoriesRequest";

import { AWARDCATEGORIES_BASE_URL } from "../Constants/SagaConstants";
import { getAuthToken } from "./ApiUtils";

/**
 * AwardCategoriesApi to create endpoints for award categories to api service calls. Authenticating with the token and appending in headers for all calls.
 */
export const awardCategoriesApi = createApi({
  reducerPath: "awardCategoriesApi",
  baseQuery: fetchBaseQuery({ baseUrl: AWARDCATEGORIES_BASE_URL,
    prepareHeaders: async (headers) => {
      // Use the getAuthToken utility to fetch and add the token
      return await getAuthToken(headers);
    },
  }),
  endpoints: (builder) => ({
    getAwardCategories: builder.query({
      query: (tenant: string) => `AwardCategories?tenant=${tenant}`,
    }),
    updateAwardCategory: builder.mutation<null, IAwardCategoriesRequest>({
      query: (awardCategory) => ({
        url: "AwardCategories/",
        method: "POST",
        body: awardCategory,
      }),
    }),
  }),
});

export const { useGetAwardCategoriesQuery, useUpdateAwardCategoryMutation } = awardCategoriesApi;
export const { getAwardCategories, updateAwardCategory } = awardCategoriesApi.endpoints;
export default awardCategoriesApi.reducer;
